<template>
    <b-modal id="petientWriteModal" :title="title" size="lg" @hidden="fn_modal_hide">
        <div class="search">
            <div class="table_list">
                <div class="modal_table user">
                    <table class="write">
                        <colgroup>
                            <col width="100">
                            <col width="200">
                            <col width="100">
                            <col width="200">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>이름</th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_nm" placeholder="입력하세요"></td>
                                <th>차트번호</th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_chart_no" placeholder="입력하세요"></td>                                
                            </tr>
                            <tr>
                                <th>성별</th>
                                <td>
                                    <div class="form_select">
                                        <b-form-select v-model="petientInfo.patient_gender_cd">
                                            <b-form-select-option :value="null">선택</b-form-select-option>
                                            <b-form-select-option value="M">남성</b-form-select-option>
                                            <b-form-select-option value="F">여성</b-form-select-option>
                                        </b-form-select>
                                    </div>
                                </td>
                                <th>환자 비고</th>
                                <td><input type="text" class="form_control" v-model="petientInfo.patient_note" placeholder="입력하세요"></td>
                            </tr>
                            <tr>
                                <th>생년월일</th>
                                <td colspan="3">
                                    <div class="form_inline">
                                        <div class="form_select">
                                            <b-form-select  v-model="petientInfo.patient_birth_year">
                                                <b-form-select-option v-for="(yyyy, index) in yearList" :key="index" :value="yyyy">{{yyyy}}년</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_birth_month">
                                                <b-form-select-option v-for="(mm, index) in monthList" :key="index" :value="mm">{{mm}}월</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_birth_day">
                                                <b-form-select-option v-for="(dd, index) in dayList" :key="index" :value="dd">{{dd}}일</b-form-select-option>
                                            </b-form-select>
                                        </div>                                    
                                    </div>
                                </td>
                            </tr>                            
                            <tr>
                                <th>전화번호</th>
                                <td colspan="3">
                                    <div class="form_inline">
                                        <div class="form_select">
                                            <b-form-select v-model="petientInfo.patient_tel_first">
                                                <b-form-select-option v-for="(telNum, index) in telList" :key="index" :value="telNum">{{telNum}}</b-form-select-option>
                                            </b-form-select>
                                        </div>
                                        -
                                        <div class="form_select">
                                            <input type="number" class="form_control" v-model="petientInfo.patient_tel_mid" placeholder="입력하세요">
                                        </div>
                                        -
                                        <div class="form_select">
                                            <input type="number" class="form_control" v-model="petientInfo.patient_tel_last" placeholder="입력하세요">
                                        </div>                                    
                                    </div>
                                </td>
                            </tr>                            
                            <tr>
                                <th>우편번호</th>
                                <td colspan="3">
                                    <div class="form_inline">
                                    <input type="text" class="form_control limit" v-model="petientInfo.patient_post_no" placeholder="입력해주세요." readonly>
                                    <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('patient')">주소검색</button>
                                    </div>
                                </td>
                            </tr>   
                            <tr>
                                <th>주소</th>
                                <td colspan="3"><input type="text" class="form_control" v-model="petientInfo.patient_addr" placeholder="입력하세요" readonly></td>
                            </tr>
                            <tr>
                                <th>상세주소</th>
                                <td colspan="3"><input type="text" class="form_control" v-model="petientInfo.patient_addr_dtl" placeholder="입력하세요"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <template #modal-footer="{ ok }">
            <b-button class="btn btn_md btn_brown" @click="fn_patient_save(),ok()">신규 환자 등록</b-button>
        </template>
    </b-modal>

</template>

<script>
    import commonUtil from "@/mixin/commonUtil";
    import axios from 'axios'

    export default {
        name: 'petientWriteModal',
        mixins: [commonUtil],
        props: {
            title: String,
        },
        data () {
            return {
                selected: null,
                petientInfo : {
                    patient_chart_no : '',
                    patient_nm : '',
                    patient_gender_cd : null,
                    patient_age : 0,
                    patient_birth_year : 0,
                    patient_birth_month : 0,
                    patient_birth_day : 0,
                    patient_tel_num : '',
                    patient_tel_first : '010',
                    patient_tel_mid : '',
                    patient_tel_last : '',
                    patient_post_no : '',
                    patient_addr : '',
                    patient_addr_dtl : '',
                    patient_note : ''
                },
                currentYear : 0,
                yearList : [],
                monthList : [],
                dayList : [],
                telList : ['010','011','016','017','018','019']

            }
        },
        created(){
            let now = new Date();	// 현재 날짜 및 시간
            this.currentYear = now.getFullYear();	// 연도

            for(let i = this.currentYear; i > this.currentYear -100; i--){
                this.yearList.push(i);
            }

            for(let i = 1; i < 13; i++){
                this.monthList.push(i);
            }

            for(let i = 1; i < 32; i++){
                this.dayList.push(i);
            }            

            this.petientInfo.patient_birth_year = this.currentYear;
            this.petientInfo.patient_birth_month = 1;
            this.petientInfo.patient_birth_day = 1;   

            this.petientInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId']                        
        },
        methods : {
            //다음주소 정보 가져오기
            callBackAddr(call,postInfo){
                
                this.petientInfo.patient_post_no = postInfo.zonecode;
                this.petientInfo.patient_addr = postInfo.roadAddress;
            },        
            //모달창이 닫힐때 마다 초기화
            fn_modal_hide(){
                this.petientInfo = {
                    patient_chart_no : '',
                    patient_nm : '',
                    patient_gender_cd : null,
                    patient_age : 0,
                    patient_birth_year : 0,
                    patient_birth_month : 0,
                    patient_birth_day : 0,
                    patient_tel_num : '',
                    patient_tel_first : '010',
                    patient_tel_mid : '',
                    patient_tel_last : '',
                    patient_post_no : '',
                    patient_addr : '',
                    patient_addr_dtl : '',
                    patient_note : '',
                    clinic_doctor_id : ''
                };

                this.petientInfo.patient_birth_year = this.currentYear;
                this.petientInfo.patient_birth_month = 1;
                this.petientInfo.patient_birth_day = 1; 
            },
            fn_patient_save(){
                
                if(this.petientInfo.patient_tel_mid != "" || this.petientInfo.patient_tel_last != ""){
                    this.petientInfo.patient_tel_num = this.petientInfo.patient_tel_first + this.petientInfo.patient_tel_mid + this.petientInfo.patient_tel_last;
                }else{
                    this.petientInfo.patient_tel_num = "";
                }

                
                this.petientInfo.patient_age = this.currentYear - this.petientInfo.patient_birth_year;

                console.log("@@@@@ param : %o",this.petientInfo);

                axios
                    .post("/api/user/petient/setPetientInfo", this.petientInfo)
                    .then((res) => {
                        console.log("@@@@ res : %o",res);
                        
                        this.$emit('callback', res.data.patient_seq);
                    })
                    .catch((err) => console.log(err));
            },
            //결제비용 하단 좌표 고정
            resetLeft () {
                if (this.isShow.patient) {
                    return this.leftArea - 540
                } else {
                    return this.leftArea
                }
            }
        }
    }
</script>

<style>

</style>